import { currentLang } from '../localization/currentLang'

const lists = document.querySelectorAll('[data-contacts-list]')

lists.forEach(el => {
  const numberItems = el.querySelectorAll('[data-lang]')

  const currentNumberEl = [...numberItems].reduce((acc, el) => {
    if (el.getAttribute('data-lang') === currentLang) {
      acc = el
    }

    return acc
  }, null)

  currentNumberEl && el.firstElementChild.before(currentNumberEl)
})
